/** @typedef {import('./SeatIconState').default} SeatIconState */


class SeatIcon {
  /**
   * @param {SeatIconState} defaultIcon
   * @param {SeatIconState} [selectedIcon]
   */
  constructor(defaultIcon, selectedIcon) {
    this.default = defaultIcon;
    this.selected = selectedIcon;
  }
}


export default SeatIcon;
